const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMhub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.981,12.174V17.01l4.755-4.836Z",
    style: {
      fill: "#12a6bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.078,12.174l4.756,4.836V12.174Z",
    style: {
      fill: "#19af97"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.166,12.174V17.01l4.756-4.836Z",
    style: {
      fill: "#19af97"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.264,12.174l4.755,4.836V12.174Z",
    style: {
      fill: "#2b954a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.736,6.99,1.981,11.826H6.736Z",
    style: {
      fill: "#12a6bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.922,6.99l-4.756,4.836h4.756Z",
    style: {
      fill: "#9bcea5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.078,6.99v4.836h4.756Z",
    style: {
      fill: "#9bcea5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.264,6.99v4.836h4.755Z",
    style: {
      fill: "#2b954a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhub);
export default __webpack_public_path__ + "static/media/mhub.4bc7fa034e525a738b15b5284e3baafd.svg";
export { ForwardRef as ReactComponent };